module.exports = __webpack_public_path__ + "img/calendar2-check-fill.3a32b577.svg";